import { useState } from 'react';
import TermsModal from './TermsModal';

function LockIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z" />
    </svg>
  );
}

const initialFormData = {
  fullName: '',
  phone: '',
  email: '',
  org: '',
  fullTimeEmployees: '',
  consent: false
};

const EMAIL_ENDPOINT = 'https://venturerev.com/api/send-email-earlychildhoodeducationassosiation';
const REDIRECT_URL = 'https://bookings.cloud.microsoft/book/AmazeHealthDiscovery@amazehealth.com/s/DG2fT1PFwEKY3wWYLHTlYA2?iismsaljsauthenabledtrue.';

export default function EstimateForm() {
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const [formData, setFormData] = useState(initialFormData);


  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormData((previous) => ({
      ...previous,
      [name]: type === 'checkbox' ? checked : value
    }));
  };


  const handleSubmit = async (event) => {
    event.preventDefault();

    setSubmitError('');
    setIsSubmitting(true);

    const payload = {
      fullName: formData.fullName,
      phone: formData.phone,
      email: formData.email,
      org: formData.org,
      fullTimeEmployees: formData.fullTimeEmployees,
      consent: formData.consent
    };

    try {
      const emailResponse = await fetch(EMAIL_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (!emailResponse.ok) {
        throw new Error('Email delivery failed.');
      }

      window.location.assign(REDIRECT_URL);
    } catch (error) {
      setSubmitError(error.message || 'Something went wrong. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="estimate-form-section">
      <TermsModal isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} />
      <div className="card form-card border-0 px-4 py-4 load-soft-scale delay-2">
        <h2 className="font-serif fw-bold text-ecec-navy h4 mb-2">Schedule today for a free consultation.</h2>
        <p className="small text-secondary mb-4">
          Takes less than a minute. Our team will reach out with a personalized plan.
        </p>
        <form onSubmit={handleSubmit}>
          <div className="row g-3 mb-3">
            <div className="col-12 col-md-6">
              <label className="form-label" htmlFor="fullName">
                Full name
              </label>
              <input
                type="text"
                className="form-control"
                id="fullName"
                name="fullName"
                value={formData.fullName}
                onChange={handleInputChange}
               
                required
              />
            </div>

            <div className="col-12 col-md-6">
              <label className="form-label" htmlFor="phone">
                Phone
              </label>
              <input
                type="tel"
                className="form-control"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                
                required
              />
            </div>
          </div>

          <div className="mb-3">
            <label className="form-label" htmlFor="email">
              Work email
            </label>
            <input
              type="email"
              className="form-control"
              id="email"
              name="email"
              value={formData.email}
             
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="mb-4">
            <label className="form-label" htmlFor="org">
              Your Child Care Center
            </label>
            <input
              type="text"
              className="form-control"
              id="org"
              name="org"
              value={formData.org}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="mb-4">
            <label className="form-label" htmlFor="fullTimeEmployees">
              How many full-time employees do you have?
            </label>
            <input
              type="number"
              className="form-control"
              id="fullTimeEmployees"
              name="fullTimeEmployees"
              value={formData.fullTimeEmployees}
              onChange={handleInputChange}
              min="0"
              required
            />
          </div>

          <div className="form-check mb-4">
            <input
              className="form-check-input"
              type="checkbox"
              id="consent"
              name="consent"
              checked={formData.consent}
              onChange={handleInputChange}
              required
            />
            <label className="form-check-label small text-secondary" htmlFor="consent">
              I agree to the{' '}
              <button
                type="button"
                className="terms-inline-button"
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  setIsTermsOpen(true);
                }}
              >
                terms and conditions
              </button>{' '}
              and consent to be contacted about this program.
            </label>
          </div>

          {submitError ? <p className="submit-error small mb-3">{submitError}</p> : null}

          <button type="submit" className="btn btn-ecec-primary w-100" disabled={isSubmitting}>
            {isSubmitting ? 'Submitting...' : 'Schedule Consult ->'}
          </button>
        </form>

        <p className="small text-secondary mt-3 form-bootmp  mb-0 d-flex align-items-center gap-2">
          <LockIcon />
          Your information is private and will never be sold or shared
        </p>
      </div>
    </section>
  );
}
